<template>
  <TableList
    class="table-container"
    :listData="listData"
    :defaultExpandAll="false"
    :tableColumns="tableColumns"
    no-operation
  >
    <template #btn-group>
      <div></div>
    </template>
  </TableList>
</template>

<script>
import TableList from './jobBoardPoint/table.vue'

export default {
  props: {
    listData: {
      required: true
    },
    i18nPrefix: {
      type: String,
      default: 'admin.company.jobPostingDetailRecord'
    },
    tableColumns: {
      required: true
    }
  },
  components: {
    TableList
  },
  data () {
    return {
    }
  },
  computed: {
  },
  created () {
  },
  mounted () {
  },
  methods: {
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
.table-container {

  .points-container {
    .points {
      display: inline-flex;
      min-width: 45px;

      &.root {
        margin-right: 17px;
      }
    }

    > i {
      cursor: pointer;
    }

  }
}
::v-deep {
  &.table-container {
    .table-header {
      display: none;
    }
  }

  .el-table {
    border: 0;
    font-size: 14px;
    &::after {
      display: none;
    }
    &::before {
      display: none;
    }
    .el-table__header-wrapper {
      .el-table__cell {
        background: #FAFAFA;
        border: 0;
        border-bottom: 1px solid #DFDFDF;

        .cell {
          border-left: 1px solid #DFDFDF;
        }

        &:first-child {
          .cell {
            border: 0;
          }
        }
      }
    }
    .el-table__body {
      border-color: #DFDFDF;
      .el-table__cell {
        border: 0;
        border-bottom: 1px solid #DFDFDF;
      }
    }
  }
}
</style>
